import React from 'react';

import { NikeRoute } from 'nike-ui/src/common/routing/types';
import { TabButton } from '@/header/HeaderTabsContainer';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';
import { COMMUNITY_ANALYSES, COMMUNITY_LOBBY, BETBOOK_TICKETS, COMMUNITY_CHAT } from '@/routing/routes';

import '@/header/HeaderTabsContainer.less';
import i18n from '@i18n';

/**
 * The API is object with keys (unordered), so we define the order
 */
const ROUTE_TABS = [COMMUNITY_LOBBY, BETBOOK_TICKETS, COMMUNITY_ANALYSES, COMMUNITY_CHAT];

/**
 * Resolves label of the tab navigation menu based on API
 * @param path
 */

interface NavTabsProps {
    active: NikeRoute;
}

const BetbookNavBar: React.FC<NavTabsProps> = ({ active }) => {
    const scrollElementRef = useHeaderTabsScroll();

    return (
        <div className="specific-navbar-tabs page-header-tabs">
            {ROUTE_TABS.map((route, idx) => (
                // @ts-expect-error missing typings
                <TabButton key={idx} route={route} activeRoute={active} scrollElementRef={scrollElementRef}>
                    {i18n('navigation.' + route.name)}
                </TabButton>
            ))}
        </div>
    );
};

export default BetbookNavBar;
